export default __webpack_public_path__ + "static/media/mini-13.ab1aca8e.jpg";